import React from "react";
import GitHubCalendar from "react-github-calendar";

export const GithubStats = () => {
  const selectLastHalfYear = (contributions) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const shownMonths = 7;

    return contributions.filter((day) => {
      const date = new Date(day.date);
      const monthOfDay = date.getMonth();

      return (
        date.getFullYear() === currentYear &&
        monthOfDay > currentMonth - shownMonths &&
        monthOfDay <= currentMonth
      );
    });
  };

  return (
    <div style={{margin: "auto", width:"40%", textAlign:"center"}}>
      <div className="github-heading" >
        <h1>GitHub</h1>
      </div>
      <div className="github-container">
        <img
          align="center"
          src="https://github-readme-stats.vercel.app/api?username=arnabdasrishi&show_icons=true&include_all_commits=true&count_private=true&hide=issues,contribs&border_radius=20&locale=en&theme=radical"
          alt="arnabdasrishi"
          height="140"
        />

        <img
          align="center"
          src="https://github-readme-stats.vercel.app/api/top-langs/?username=arnabdasrishi&layout=compact&hide=Shell&border_radius=20&theme=radical"
          alt="arnabdasrishi"
          height="140"
        />
      </div>

      <div className="github-calender" style={{marginTop:"3rem", marginBottom:"3rem"}}>
        <GitHubCalendar
          username="arnabdasrishi"
          color={"green"}
        />
      </div>
    </div>
  );
};
